import React from "react";
import Header from "../../../shared/layout/Header";
import ColorInit from "../../../shared/layout/ColorInit";
import { CartProvider } from "../../cart/context/CartContext";
import Footer from "../../../shared/layout/Footer";
import BottomFooter from "../../../shared/layout/BottomFooter";
import GuestCoupon from "../components/GuestCoupon";
import ScrollToTop from "react-scroll-to-top";

const GuestCouponPage = () => {
  return (
    <CartProvider>
      <ScrollToTop smooth color="#ef253c" />
      <ColorInit color={"bigmall"} />
      <Header />
      <GuestCoupon />
      <Footer />
      <BottomFooter />
    </CartProvider>
  );
};
export default GuestCouponPage;
